module.exports = __webpack_public_path__ + "img/home-cover-2.6551904a.png";